import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import styles from './Contact.module.css';

// Добавляем функцию для отправки событий в Яндекс.Метрику
const sendMetrikaEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.ym) {
    window.ym(105284877, 'reachGoal', eventName, eventParams);
  }
};

// Кастомный хук для маски телефона (если usePhoneMask не работает)
const usePhoneMask = () => {
  const [phone, setPhone] = useState('');

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    
    if (value.length > 0) {
      value = value.substring(0, 11);
      let formattedValue = '+7';
      
      if (value.length > 1) {
        formattedValue += ` (${value.substring(1, 4)}`;
      }
      if (value.length >= 5) {
        formattedValue += `) ${value.substring(4, 7)}`;
      }
      if (value.length >= 8) {
        formattedValue += `-${value.substring(7, 9)}`;
      }
      if (value.length >= 10) {
        formattedValue += `-${value.substring(9, 11)}`;
      }
      
      setPhone(formattedValue);
    } else {
      setPhone('');
    }
  };

  return [phone, handlePhoneChange];
};

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [errors, setErrors] = useState({});
  
  const phoneRegExp = /^\+7 \([0-9]{3}\) [0-9]{3}-[0-9]{2}-[0-9]{2}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const services = [
    { value: 'hotel', label: 'Гостиничные чеки' },
    { value: 'construction', label: 'Строительные материалы' },
    { value: 'restaurant', label: 'Рестораны и кафе' },
    { value: 'auto', label: 'Автомобильные услуги' },
    { value: 'other', label: 'Другое' }
  ];

  const socialLinks = [
    { name: 'WhatsApp', icon: 'fab fa-whatsapp', url: 'https://wa.me/79874817932', color: '#25D366' },
    { name: 'Telegram', icon: 'fab fa-telegram', url: 'https://t.me/regioncheck_bot', color: '#0088cc' },
    { name: 'Email', icon: 'fas fa-envelope', url: 'mailto:mirat7932@mail.ru', color: '#EA4335' }
  ];

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Введите ваше имя';
    }
    
    if (!phoneRegExp.test(formData.phone)) {
      newErrors.phone = 'Введите корректный номер телефона';
    }
    
    if (formData.email && !emailRegex.test(formData.email)) {
      newErrors.email = 'Введите корректный email адрес';
    }
    
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Обработка телефона с маской
    if (name === 'phone') {
      let phoneValue = value.replace(/\D/g, '');
      
      if (phoneValue.length > 0) {
        phoneValue = phoneValue.substring(0, 11);
        let formattedValue = '+7';
        
        if (phoneValue.length > 1) {
          formattedValue += ` (${phoneValue.substring(1, 4)}`;
        }
        if (phoneValue.length >= 5) {
          formattedValue += `) ${phoneValue.substring(4, 7)}`;
        }
        if (phoneValue.length >= 8) {
          formattedValue += `-${phoneValue.substring(7, 9)}`;
        }
        if (phoneValue.length >= 10) {
          formattedValue += `-${phoneValue.substring(9, 11)}`;
        }
        
        setFormData(prev => ({
          ...prev,
          [name]: formattedValue
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          [name]: ''
        }));
      }
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
    
    // Сброс ошибки при изменении поля
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrors({});
    
    const validationErrors = validateForm();
    
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      
      // Отслеживаем ошибки валидации формы
      sendMetrikaEvent('consultation_validation_error', {
        form_type: 'contact_form',
        errors: Object.keys(validationErrors)
      });
      
      setIsSubmitting(false);
      return;
    }

    try {
      // Отправляем событие в Яндекс.Метрику при успешной валидации формы
      sendMetrikaEvent('consultation_order', {
        form_type: 'contact_form',
        phone_provided: !!formData.phone,
        email_provided: !!formData.email,
        name_provided: !!formData.name,
        message_provided: !!formData.message,
        service_provided: !!formData.service,
        source: 'contact_section'
      });

      // Отправка через EmailJS
      const templateParams = {
        name: formData.name,
        phone: formData.phone,
        email: formData.email,
        service: formData.service ? services.find(s => s.value === formData.service)?.label || formData.service : 'Не указано',
        message: formData.message || 'Не указано'
      };

      await emailjs.send(
        'service_f3d3gpm',
        'template_46r6p8s',
        templateParams,
        '9UYBO40lGP0XwuZ7m'
      );
      
      // Дополнительное событие при успешной отправке на сервер
      sendMetrikaEvent('consultation_success', {
        form_type: 'contact_form',
        status: 'success'
      });

      // Сброс формы и показ сообщения об успехе
      setFormData({
        name: '',
        phone: '',
        email: '',
        service: '',
        message: ''
      });
      
      setSubmitSuccess(true);
      
      // Автоматическое закрытие сообщения об успехе через 5 секунд
      setTimeout(() => {
        setSubmitSuccess(false);
      }, 5000);
      
    } catch (error) {
      console.error('Ошибка при отправке', error);
      
      // Событие при ошибке отправки
      sendMetrikaEvent('consultation_error', {
        form_type: 'contact_form',
        status: 'error',
        error_type: 'emailjs_failed'
      });
      
      setErrors({ submit: 'Произошла ошибка при отправке. Пожалуйста, попробуйте еще раз.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Простая модалка для сообщения об успехе
  const SuccessModal = () => {
    if (!submitSuccess) return null;
    
    return (
      <div className={styles.successModal}>
        <div className={styles.successModalContent}>
          <div className={styles.successIcon}>✓</div>
          <h3>Спасибо за заявку!</h3>
          <p>Мы свяжемся с вами в ближайшее время</p>
          <button 
            className={styles.successCloseBtn}
            onClick={() => setSubmitSuccess(false)}
          >
            Закрыть
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      <section id="contact" className={`section ${styles.contact}`}>
        <div className="container">
          <div className={styles.contactContent}>
            <div className={styles.contactHeader}>
              <h2 className="section-title">
                СВЯЖИТЕСЬ <span className="section-title--accent">С НАМИ</span>
              </h2>
              <p className="section-subtitle">
                Оставьте заявку и мы свяжемся с вами в течение 15 минут
              </p>
            </div>

            <div className={styles.contactGrid}>
              <div className={styles.contactInfo}>
                <div className={`card ${styles.infoCard}`}>
                  <h3 className={styles.infoTitle}>Контакты</h3>
                  
                  <div className={styles.contactItem}>
                    <div className={styles.contactIcon}>
                      <i className="fas fa-phone-alt"></i>
                    </div>
                    <div>
                      <div className={styles.contactValue}>+7 (987) 481-79-32</div>
                      <div className={styles.contactLabel}>Основной телефон</div>
                    </div>
                  </div>

                  <div className={styles.contactItem}>
                    <div className={styles.contactIcon}>
                      <i className="fas fa-mobile-alt"></i>
                    </div>
                    <div>
                      <div className={styles.contactValue}>+7 (987) 481-79-32</div>
                      <div className={styles.contactLabel}>WhatsApp / Telegram</div>
                    </div>
                  </div>

                  <div className={styles.contactItem}>
                    <div className={styles.contactIcon}>
                      <i className="fas fa-envelope"></i>
                    </div>
                    <div>
                      <div className={styles.contactValue}>mirat7932@mail.ru</div>
                      <div className={styles.contactLabel}>Электронная почта</div>
                    </div>
                  </div>

                  <div className={styles.contactItem}>
                    <div className={styles.contactIcon}>
                      <i className="fas fa-map-marker-alt"></i>
                    </div>
                    <div>
                      <div className={styles.contactValue}>Москва</div>
                      <div className={styles.contactLabel}>Самовывоз</div>
                    </div>
                  </div>

                  <div className={styles.deliveryInfo}>
                    <i className="fas fa-shipping-fast"></i>
                    <span>Бесплатная доставка по Москве в пределах МКАД</span>
                  </div>

                  <div className={styles.socialLinks}>
                    {socialLinks.map((social, index) => (
                      <a
                        key={index}
                        href={social.url}
                        className={styles.socialLink}
                        style={{ '--social-color': social.color }}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={social.name}
                      >
                        <i className={social.icon}></i>
                      </a>
                    ))}
                  </div>
                </div>

                {/* <div className={`card ${styles.hoursCard}`}>
                  <h3 className={styles.hoursTitle}>Часы работы</h3>
                  <div className={styles.hoursList}>
                    <div className={styles.hoursItem}>
                      <span>Пн-Пт</span>
                      <span>9:00 - 21:00</span>
                    </div>
                    <div className={styles.hoursItem}>
                      <span>Сб</span>
                      <span>10:00 - 20:00</span>
                    </div>
                    <div className={styles.hoursItem}>
                      <span>Вс</span>
                      <span>10:00 - 18:00</span>
                    </div>
                  </div>
                  <div className={styles.emergency}>
                    <i className="fas fa-exclamation-circle"></i>
                    <span>Срочные заказы принимаются круглосуточно</span>
                  </div>
                </div> */}
              </div>

              <div className={styles.contactForm}>
                <div className={`card ${styles.formCard}`}>
                  <h3 className={styles.formTitle}>Оставить заявку</h3>
                  
                  {submitSuccess && (
                    <div className={styles.successMessage}>
                      <i className="fas fa-check-circle"></i>
                      <span>Заявка успешно отправлена! Мы свяжемся с вами в ближайшее время.</span>
                    </div>
                  )}

                  <form onSubmit={handleSubmit} className={styles.form}>
                    <div className={styles.formGroup}>
                      <label htmlFor="name" className={styles.formLabel}>
                        <i className="fas fa-user"></i>
                        Ваше имя *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className={`${styles.formInput} ${errors.name ? styles.inputError : ''}`}
                        placeholder="Иван Иванов"
                        required
                      />
                      {errors.name && <span className={styles.error}>{errors.name}</span>}
                    </div>

                    <div className={styles.formGroup}>
                      <label htmlFor="phone" className={styles.formLabel}>
                        <i className="fas fa-phone"></i>
                        Телефон *
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className={`${styles.formInput} ${errors.phone ? styles.inputError : ''}`}
                        placeholder="+7 (999) 123-45-67"
                        required
                      />
                      {errors.phone && <span className={styles.error}>{errors.phone}</span>}
                    </div>

                    <div className={styles.formGroup}>
                      <label htmlFor="email" className={styles.formLabel}>
                        <i className="fas fa-envelope"></i>
                        Email (необязательно)
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className={`${styles.formInput} ${errors.email ? styles.inputError : ''}`}
                        placeholder="example@mail.ru"
                      />
                      {errors.email && <span className={styles.error}>{errors.email}</span>}
                    </div>
{/* 
                    <div className={styles.formGroup}>
                      <label htmlFor="service" className={styles.formLabel}>
                        <i className="fas fa-list"></i>
                        Какая услуга нужна?
                      </label>
                      <select
                        id="service"
                        name="service"
                        value={formData.service}
                        onChange={handleChange}
                        className={styles.formSelect}
                      >
                        <option value="">Выберите услугу</option>
                        {services.map(service => (
                          <option key={service.value} value={service.value}>
                            {service.label}
                          </option>
                        ))}
                      </select>
                    </div> */}

                    <div className={styles.formGroup}>
                      <label htmlFor="message" className={styles.formLabel}>
                        <i className="fas fa-comment"></i>
                        Дополнительная информация
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        className={styles.formTextarea}
                        placeholder="Опишите подробнее, что вам нужно..."
                        rows="4"
                      />
                    </div>

                    {errors.submit && (
                      <div className={styles.formGroup}>
                        <span className={styles.submitError}>{errors.submit}</span>
                      </div>
                    )}

                    <button
                      type="submit"
                      className={`btn btn--primary ${styles.submitButton} ${isSubmitting ? styles.submitting : ''}`}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <>
                          <i className="fas fa-spinner fa-spin"></i>
                          Отправка...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-paper-plane"></i>
                          Отправить заявку
                        </>
                      )}
                    </button>
                  </form>
                </div>
              </div>
            </div>

            <div className={styles.contactFooter}>
              <div className={styles.footerContent}>
                <div className={styles.footerLogo}>
                  <i className="fas fa-qrcode"></i>
                  <span>Чеки Москва</span>
                </div>
                <div className={styles.footerText}>
                  <p>Официальные кассовые чеки с QR-кодом ФНС в Москве</p>
                  <p className={styles.footerCopyright}>
                    © {new Date().getFullYear()}. Все права защищены.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SuccessModal />
    </>
  );
};

export default Contact;